export interface ICoord {
  lat: number;
  lng: number;
}

export const defaultValue: Readonly<ICoord> = {
  lat: 0,
  lng: 0
};
